import { RoomType } from "../../../types";

export enum LinkedRoomRelationshipType {
  RELATED = 'related',
  PARENT = 'parent',
  CHILD = 'child',
  ALL = 'all',
}

export enum LinkedRoomJoinType {
  MANUAL_JOIN = 'manualjoin',
  AUTO_JOIN = 'autojoin'
}

export type LinkedRoom = {
  id: string;
  isMemberOfRoom: boolean;
  isVisible: boolean;
  joinInviteId: string;
  joinType: LinkedRoomJoinType;
  linkedRoomsCount: number;
  picurl?: string;
  relationshipType: LinkedRoomRelationshipType;
  title: string;
  type: RoomType;
}